import BaseModel from "./BaseModel";

class Tier extends BaseModel {
	constructor(data) {
		super({}, Tier.defaults);
		this.data = data;
	}

	isNew() {
		return typeof this.id === "undefined" || this.id === -1;
	}

	clone() {
		return new Tier(this.data);
	}

	get id() {
		return this.get("id");
	}

	get name() {
		return this.get("name");
	}

	get notes() {
		return this.get("notes");
	}

	get alertTypes() {
		return this.get("alert_types");
	}

	get rois() {
		return this.get("rois");
	}

	get features() {
		return this.get("features");
	}

	get userLimit() {
		return this.get("user_limit");
	}

	get alertTypeLimit() {
		return this.get("alert_type_limit");
	}

	get roiPerAlertTypeLimit() {
		return this.get("roi_per_alert_type_limit");
	}

	update(data) {
		super.setData(data);
	}
}
Tier.defaults = { // Defaults
	id: -1,
	name: "",
	notes: "",
	alert_types: [],
	rois: [],
	features: {},
	user_limit: -1,
	alert_type_limit: -1,
	roi_per_alert_type_limit: -1
};

export default Tier;
